export function getMatchingTimezoneByName(name, timezones = []) {
    return timezones.find((timezone) => timezone.time_zone === name);
}